import * as React from 'react';
import { EntityView } from 'app/infrastructure/ui/renderer';
import {SpinLoader} from 'app/components/spin-loader';
import { ScrollToTop } from 'ui/scroll-to-top/scroll-to-top';

export const CaseView = (props : any) => {

  if (!props.schema || !props.entityId) {
    return <SpinLoader />;
  }

  return <><EntityView
      key={props.entityId}
      {...props}
  />
    <ScrollToTop/>
  </>;

};
